var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasContacts || _vm.hasLinks || _vm.hasLogos
    ? _c("footer", { staticClass: "ct-footer" }, [
        _vm.hasContacts
          ? _c(
              "div",
              { staticClass: "ct-footer__contacts" },
              _vm._l(_vm.contacts, function (contact, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "ct-footer__contacts__contact" },
                  [
                    _c("p", [_vm._v(_vm._s(contact.name))]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: _vm.contactHref(contact.value) } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(contact.value) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasLinks
          ? _c(
              "div",
              { staticClass: "ct-footer__links d-flex flex-column" },
              _vm._l(_vm.links, function (link, index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    staticClass: "ct-footer__link",
                    attrs: { to: _vm.routerLink(link) },
                  },
                  [_vm._v("\n            " + _vm._s(link.title) + "\n        ")]
                )
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasLogos
          ? _c(
              "div",
              { staticClass: "ct-footer__logos" },
              [
                _vm._l(_vm.logos, function (logo, index) {
                  return [
                    logo.route
                      ? [
                          _c(
                            "router-link",
                            {
                              key: index,
                              attrs: {
                                title: logo.name,
                                "data-toggle": "tooltip-city",
                                to: { name: logo.route },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  alt: logo.name,
                                  src: _vm.assetsPathGlobalPlatform(
                                    `/${logo.path}`
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      : logo.link
                      ? [
                          _c(
                            "a",
                            {
                              key: index,
                              attrs: {
                                "data-toggle": "tooltip-city",
                                title: logo.name,
                                href: logo.link,
                                target: "_blank",
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  alt: logo.name,
                                  src: _vm.assetsPathGlobalPlatform(
                                    `/${logo.path}`
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      : [
                          _c("img", {
                            key: index,
                            attrs: {
                              "data-toggle": "tooltip-city",
                              title: logo.name,
                              alt: logo.name,
                              src: _vm.assetsPathGlobalPlatform(
                                `/${logo.path}`
                              ),
                            },
                          }),
                        ],
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }